import React, { memo, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { Button, Modal, Switch, Typography } from 'antd';

import axios from 'axios';

type BillingReminderTermsDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const TERMS_PDF_URL = 'https://cdn.eduzzcdn.com/myeduzz/upload/8c/3b/8c3b6d28d6d843248ec8e1440a31411d';

async function fetchPdfObjectUrl(): Promise<string> {
  const response = await axios.get(TERMS_PDF_URL, { responseType: 'blob' });
  const blob = response.data as Blob;
  return URL.createObjectURL(blob);
}

function BillingReminderTermsDialogComponent({ open, onClose, onConfirm }: BillingReminderTermsDialogProps) {
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const objectUrlRef = useRef<string | null>(null);
  const [pdfSrc, setPdfSrc] = useState<string>('');

  useEffect(
    function setupPdfSource() {
      let cancelled = false;

      const cleanup = () => {
        cancelled = true;
      };

      if (!open) {
        return cleanup;
      }

      setHasAcceptedTerms(false);

      if (objectUrlRef.current) {
        setPdfSrc(objectUrlRef.current);
        return cleanup;
      }

      fetchPdfObjectUrl()
        .then(objUrl => {
          if (cancelled) {
            URL.revokeObjectURL(objUrl);
            return;
          }

          objectUrlRef.current = objUrl;
          setPdfSrc(objUrl);
        })
        .catch(() => {
          setPdfSrc(TERMS_PDF_URL);
          toast.error(
            'Erro ao carregar o termo de responsabilidade. Realizando o download do termo de responsabilidade.'
          );
        });

      return cleanup;
    },
    [open]
  );

  useEffect(function cleanupPdfObjectUrl() {
    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, []);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={900}
      title={
        <Typography.Title level={5} style={{ margin: 0 }}>
          Termo de responsabilidade
        </Typography.Title>
      }
      footer={[
        <Button key='cancel' onClick={onClose}>
          Cancelar
        </Button>,
        <Button key='confirm' type='primary' onClick={onConfirm} disabled={!hasAcceptedTerms}>
          Confirmar desativação
        </Button>
      ]}
    >
      <Typography.Text style={{ display: 'block', marginBottom: 12 }}>
        Antes de desativar o envio de notificações de renovação, leia e aceite o termo de responsabilidade abaixo. Essa
        confirmação é importante para garantir transparência ao seu cliente sobre a continuidade das cobranças.
      </Typography.Text>

      <div style={{ width: '100%', height: 450, border: 0 }}>
        <iframe
          src={`${pdfSrc}#toolbar=1`}
          title='termo-de-responsabilidade'
          style={{ border: 0, width: '100%', height: '100%' }}
        />
      </div>

      <div className='mt-4 flex items-center gap-2'>
        <Switch checked={hasAcceptedTerms} onChange={setHasAcceptedTerms} />
        <span>Li e aceito o termo de responsabilidade</span>
      </div>
    </Modal>
  );
}

export const BillingReminderTermsDialog = memo(BillingReminderTermsDialogComponent);
